import { type CustomerId, type DeviceId } from '@solinkcorp/api-types';
import { useUserSession } from '@solinkcorp/authentication';
import CloudAiApi from 'clients/CloudAiApi';
import useSWR from 'swr';

function useIsolatedDeviceSpotCheckUsage(
  shouldFetch = false,
  deviceIds: DeviceId[],
): {
  isLoading: boolean;
  estimatedTotalIsolatedRemainingQuota?: number;
  correspondingTotalQuota?: number;
} {
  const userSession = useUserSession();
  const customerId = userSession.profile?.customerId;

  const { data: usageStats, isLoading } = useSWR(
    shouldFetch ? ['device-spot-check-usage-stats', deviceIds] : null,
    () =>
      CloudAiApi.getIsolatedDeviceSpotCheckUsage(
        userSession.accessToken,
        customerId as CustomerId,
        deviceIds,
      ),
    {
      revalidateOnFocus: false,
      errorRetryCount: 3,
    },
  );

  return {
    isLoading,
    estimatedTotalIsolatedRemainingQuota: usageStats?.estimatedTotalIsolatedRemainingQuota,
    correspondingTotalQuota: usageStats?.correspondingTotalQuota,
  };
}

export default useIsolatedDeviceSpotCheckUsage;
